import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getUploadFilesData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/upload${q}`, {
    headers: {
      // "Access-Control-Allow-Origin": "*", // Add this line
      authorization: token,
    },
  });
}
export const uploadAttachment = (myFile, token) => {
  return axios.post(`${baseUrl}/upload`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
export function getUploadFilesDataFromDataBase(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getfiles${q}`, {
    headers: {
      // "Access-Control-Allow-Origin": "*", // Add this line
      authorization: token,
    },
  });
}
